import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import type {
  RichTextComponentType,
  RichTextBlockStateType,
} from '@unifyapps/defs/blocks/RichText/types';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importRichTextComponent = () =>
  import(
    /* webpackChunkName: "richText-block" */
    './RichText'
  );

const RichText = lazy(importRichTextComponent);

class RichTextBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return RichText;
  }

  get type(): ComponentTypeUnionType {
    return 'RichText';
  }
  get initialStateGetter() {
    return (block: BlockType<RichTextComponentType>) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as RichTextBlockStateType;
  }
}

export default RichTextBlockStateDefinition;
